/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import AsyncApiComponent from "@asyncapi/react-component";
// import "@asyncapi/react-component/styles/default.css"
import "./asyncapi.css";

export const convertCustomSpecToAsyncapi = (content: any, eventTitle: string, version: string ) => {
    const asyncapiSpec = {
        asyncapi: '2.3.0',
        info: {
            title: eventTitle,
            version: version
        },
        channels: {
            channelName: {
                publish: {
                    message: {
                        schemaFormat: '',
                        examples: [],
                        payload: {}
                    }
                }
            }
        }
    };
    if (!content?.asyncapi) {
        asyncapiSpec.channels.channelName.publish.message.payload = content.schema;
        asyncapiSpec.channels.channelName.publish.message.schemaFormat = content.schemaformat;
        const example = content.examples?.map((example: any) => {
            return {
                name: example?.title,
                summary: example?.description,
                payload: example?.payload
            };
        });
        asyncapiSpec.channels.channelName.publish.message.examples = example;
    } else {
        return content;
    }
    return asyncapiSpec;
};

function App() {
    const [specUrl, setSpecUrl] = useState<string>();
    const [accessToken, setAccessToken] = useState<string>();
    const [asyncapi, setAsyncapi] = useState<any>();
    const [loading, setLoading] = useState<boolean>(true);
    useEffect(() => {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const url = urlParams.get("spec");
        const token = urlParams.get("access_token");
        url && setSpecUrl(url);
        token && setAccessToken(token);
    }, []);

    useEffect(() => {
        if (specUrl) {
            setLoading(true);
            fetchData(specUrl);
        } else {
            setLoading(false);
        }
    }, [specUrl]);

    const defaultOptions = {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    };

    const fetchData = async (url: string) => {
        try {
            const response = await fetch(url, defaultOptions);
            const json = await response?.json();
            setLoading(false);
            setAsyncapi(convertCustomSpecToAsyncapi(json?.spec, json?.eventTitle, json?.eventVersion));
        } catch (error) {
            setLoading(false);
            console.log("error", error);
        }
    };

    return (
        <div className="App">
            {loading ? (
                <h3>Loading ...</h3>
            ) : (
                <>
                    {!asyncapi && <body data-new-gr-c-s-check-loaded="14.1207.0" data-gr-ext-installed="">
                        <noscript>You need to enable JavaScript to run this app.</noscript>
                        <div id="root"><div className="error">Event specification not available</div></div></body>}
                    <AsyncApiComponent
                        schema={asyncapi}
                        config={{
                            show: {
                                errors: false,
                            },
                            expand: {
                                messageExamples: true,
                            },
                        }}
                    />
                </>
            )}
        </div>
    );
}

export default App;
